import IService from '../IService';

export default IService.extend({
  _getUrl: function () {
    return app.apiUrl('/api/v1/assets/maps');
  },

  abort: function () {
    if (app.xhrExpected(this.$ajax)) {
      this.$ajax.abort();
      this.$ajax = null;
    }
  },

  /**
   * Resolved if user is authenticated
   * @return {Promise}
   */
  get: function (data) {
    if (app.xhrExpected(this.$ajax) && this.LastSearch !== data) {
      this.$ajax.abort();
    }

    const deferred = new $.Deferred();
    this.LastSearch = data;
    this.$ajax = $.ajax({
      url: this._getUrl(),
      contentType: 'application/json',
      data: data,
      error: function (jqXHR) {
        // var response =[{"suggested":"Hill","family":"Creative"
        // ,"score":4.874655,"totalCount":14192,
        // eslint-disable-next-line max-len
        // "isFresh":false},{"suggested":"Hill Range","family":"Creative","score":0.03131182,"totalCount":95,"isFresh":false},{"suggested":"Beverly Hills","family":"Editorial","score":4161.3228,"totalCount":19324,"isFresh":false},{"suggested":"Hillary Clinton","family":"Editorial","score":4.8770967
        // eslint-disable-next-line max-len
        // ,"totalCount":2442,"isFresh":false},{"suggested":"Greenacres - Beverly Hills","family":"Editorial","score":558.75836,"totalCount":488,"isFresh":false}];
        // deferred.resolve(response);

        deferred.reject(jqXHR);
      },
      /**
       * Response values:
       * true :== session is known by the server, user authenticated
       * false :== user lost authentication, was logged out
       * null :== exception
       */
      success: function (response) {
        if (!_.isEmpty(response)) {
          const r = _.map(response.maps, (i) => ({
            suggested: i.description,
            descriptionId: i.descriptionId,
            id: i.id,
          }));
          deferred.resolve(r);
        } else {
          deferred.reject(response);
        }
      },
    }).always(() => {
      this.$ajax = null;
    });

    const promise = deferred.promise();

    return Promise.resolve(promise);
  },
});
